export default {
  actions: {
    copied: "Копирано во клипборд",
    copyFailed: "Неуспешно копирање",
    pdfDownloaded: "PDF е преземен за визита #{visitId}",
    pdfDownloadFailed: "Неуспешно преземање на PDF",
    loadVisitResultsFailed: "Неуспешно вчитување на резултатите од визита",
    loadTestHistoryFailed: "Неуспешно вчитување на историјата на испитувањето",
    loadVisitFlagsFailed: "Неуспешно вчитување на флаговите на визита",
    channelStarted: "{channelName} успешно е стартуван",
    channelStartFailed: "Неуспешно стартување на {channelName}",
    channelStopped: "{channelName} успешно е запрен",
    channelStopFailed: "Неуспешно запирање на {channelName}",
    cacheCleared: "Серверскиот кеш успешно е исчистен",
    cacheClearFailed: "Неуспешно чистење на серверскиот кеш",
    featureNotImplemented: "Оваа функција сè уште не е достапна",
    refreshFailed: "Неуспешно освежување \u2014 се прикажуваат последните познати податоци.",
  },

  tooltips: {
    copyBarcode: "Копирање на баркодот во клипборд",
  },
};
